import { Head, useForm } from "@inertiajs/react";
import AuthLayout from "@/layouts/auth-layout";
import StepForm from "@/pages/steps/step-form";
import { buildStepFormData, serializeStep } from "@/pages/steps/form-utils";
import { product_path, product_step_path, products_path } from "@/routes";

function EditStep({ product, step, templates = [], errors }) {
  const { data, setData, patch, processing, transform } = useForm(buildStepFormData(step));

  const submit = (event) => {
    event.preventDefault();
    transform(() => ({ step: serializeStep(data.step) }));
    patch(product_step_path(product.id, step.id));
  };

  return (
    <>
      <Head title={`Redigér ${step.name}`} />

      <StepForm
        data={data}
        setData={setData}
        templates={templates}
        errors={errors}
        processing={processing}
        onSubmit={submit}
        submitLabel="Gem ændringer"
      />
    </>
  );
}

EditStep.layout = (page) => {
  const { product, step } = page.props;

  return (
    <AuthLayout
      header={{
        breadcrumbs: [
          { label: "Produkter", href: products_path() },
          { label: product.name, href: product_path(product.id) },
          { label: step.name, href: product_step_path(product.id, step.id) },
          { label: "Redigér" }
        ],
        title: "Redigér",
        actions: [
          {
            href: product_path(product.id),
            label: "Tilbage",
            variant: "outline-secondary"
          },
          {
            href: product_step_path(product.id, step.id),
            label: "Se",
            variant: "outline-secondary"
          }
        ]
      }}
    >
      {page}
    </AuthLayout>
  );
};

export default EditStep;
